import React from 'react';
import styled from 'styled-components';
import { SectionTitle } from '../shared'
import briefcase from '../../assets/briefcase.svg'
import building from '../../assets/building.svg'
import hands from '../../assets/hands.svg'
import heart from '../../assets/heart.svg'
import money from '../../assets/money.svg'
import globe from '../../assets/globe.svg'

const BenefitsWrapper = styled.section`
  background: linear-gradient(180deg, #001a33 0%, #002b55 100%);
  text-align: center;
  padding: 3rem 10% 5rem;

  .benefits-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    justify-content: center;
    margin-top: 1rem;
  }

  .benefit-tile {
    position: relative;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 14px;
    padding: 32px 28px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;
    transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
  }

  /* Red accent bar that slides in on hover */
  .benefit-tile::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 100%;
    height: 4px;
    background: linear-gradient(90deg, #d52027, #990000);
    transition: right 0.3s ease;
  }

  .benefit-tile:hover {
    transform: translateY(-6px);
    background: rgba(255, 255, 255, 0.09);
    border-color: rgba(213, 32, 39, 0.55);
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);

    &::before {
      right: 0;
    }
  }

  .tile-icon {
    width: 56px;
    height: 56px;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    padding: 8px;
    box-shadow: 0 0 0 4px rgba(213, 32, 39, 0.35);
    transition: box-shadow 0.25s ease, transform 0.25s ease;
  }

  .benefit-tile:hover .tile-icon {
    box-shadow: 0 0 0 6px rgba(213, 32, 39, 0.6);
    transform: scale(1.06);
  }

  .tile-icon img {
    max-width: 100%;
    max-height: 100%;
  }

  h3 {
    font-size: 21px;
    font-weight: 800;
    letter-spacing: 0.01em;
    margin-bottom: 8px;
    text-align: left;
    color: #fff;
  }

  p {
    font-size: 15px;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.82);
    text-align: left;
    margin: 0;
  }

  @media (max-width: 992px) {
    padding: 3rem 6% 4rem;
    .benefits-container {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 768px) {
    .benefits-container {
      grid-template-columns: 1fr;
    }
  }
`;

const Benefits = () => {
  const benefits = [
    {
      title: 'Global Community',
      description: "The Podcast Incubator brings together creators from all parts of the world. Our cohorts have included voices from Nigeria, Qatar, the Shinnecock Nation, Alaska and more - creating a community where diverse perspectives strengthen everyone's work.",
      icon: globe,
    },
    {
      title: 'Safe Creative Space',
      description: "We're committed to building inclusive spaces for every person, centered around open, honest and considerate communication. This is where you can take creative risks and get the feedback that actually helps.",
      icon: heart,
    },
    {
      title: 'Real Feedback, Real Growth',
      description: "Get personalized editorial guidance from working podcast professionals and honest critiques from industry leaders. This isn't generic advice - it's specific feedback on your actual work that moves you forward.",
      icon: hands,
    },
    {
      title: 'Industry Connections',
      description: "We offer access to podcast conferences and connections to studios, including Spotify, iHeartRadio, and WNYC. Learn from the people making decisions in this industry.",
      icon: briefcase,
    },
    {
      title: 'Marketing That Works',
      description: "Stop throwing content into the void. Learn how to identify your ideal listener, where to find them, and how to build genuine connection rather than just chasing download numbers.",
      icon: building,
    },
    {
      title: 'Smart Monetization Strategies',
      description: "Understand the pros and cons of different revenue models - from sponsorships to subscriptions to premium content. Make informed decisions about what makes sense for your show and your goals.",
      icon: money,
    },
  ];

  return (
    <BenefitsWrapper>
      <SectionTitle color="white">Program Benefits</SectionTitle>
      <div className="benefits-container">
        {benefits.map((benefit, index) => (
          <div className="benefit-tile" key={index}>
            <div className="tile-icon">
              <img src={benefit.icon} alt="Benefit Icon" />
            </div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </BenefitsWrapper>
  );
};

export default Benefits;
